import styled from '../../../node_modules/styled-components';
import { Flex } from 'rebass';

export const CenterContainer = styled(Flex)`
  margin: 0 auto;
  text-align: center;
`;

export const FormContainer = styled(Flex)`
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
`



// WEBPACK FOOTER //
// ./src/components_new/common/Containers.js